export default __webpack_public_path__ + "static/media/train42.488d0d44.png";